module.exports = __webpack_public_path__ + "img/Milad_Rahatianpur_verbeterd.aab5168e.jpg";